export default class DetailPage {
    static DETAIL_STUDENT = 0;
    static TEMP_AUTH = 1;
    static NONE = 2;
    static SEARCH_STUDENT = 3;
    static DETAIL_CHECKPOINT = 4;
    static DETAIL_VEHICLE = 5;
    static CALL_STUDENT = 6;
    static GUARDIAN_CALL_STUDENT = 7;
}